{
    "searchBox":{
        "placeholder":"品番、型番、タイトルまたはドキュメント内容を入力してください"
    },
    "common":{
        "home": "Home",
        "customer_registration":"お客様登録",
        "guest_register":"アカウントの作成",
        "register_site_company":"貴社情報を入力してください*",
        "register_site_companyrole":"業界の役割*",
        "register_email_mandatory":"会社の電子メールアドレス*",
        "register_pwd":"パスワード*",
        "register_checkPwd":"パスワードの確認*",
        "register_title":"タイトル",
        "register_firstName":"名*",
        "register_lastName":"姓*",
        "register_company_accessRequesting":"アクセス権の要求",
        "register_company_name":"会社名*",
        "register_company_address_street":"番地を含む住所*",
        "register_company_address_two":"ビル、建物名",
        "register_company_address_city":"市*",
        "register_company_address_zip":"郵便番号*",
        "register_company_countryCode":"国*",
        "register_company_companyStateCode":"州*",
        "register_company_phoneNumber":"電話番号",
        "register_company_faxNumber":"FAX番号",
        "register_company_website":"ウェブサイトアドレス",
        "register_company_additionalSoldToLocations":"追加の販売場所",
        "register_dataprotection_acceptNA":"I Accept the",
        "register_terms_condition":"利用規約",
        "register_new_customer":"アカウントの作成",
        "form_register_empty":"国を選択してください",
        "register_state_placeholder":"都道府県を選択してください",
        "register_company_industryRole_invalid":"少なくとも1つの業界役割を選択してください",
        "register_email_invalid":"有効な電子メールを入力してください",
        "register_checkPwd_invalid":"パスワードを確認してください",
        "register_firstName_invalid":"名を入力してください",
        "register_lastName_invalid":"姓を入力してくださいe",
        "register_company_accessRequesting_invalid":"少なくとも1つのアクセス権を選択してください",
        "register_company_name_invalid":"会社名を入力してください",
        "register_company_address_street_invalid":"会社の住所を入力してください",
        "register_company_address_city_invalid":"会社が所在する市区町村を入力してください",
        "register_company_address_zip_invalid":"会社の郵便番号を入力してください",
        "register_company_countryCode_invalid":"会社が所在する国を選択してください",
        "register_company_companyStateCode_invalid":"会社が所在する州を入力してください",
        "register_termsOfUsage_accept_invalid":"ウェブショップの利用規約に同意する必要があります",
        "register_termOfUsage_accept_dataProtection":"データ保護宣言に同意する必要があります",
        "register_site_description":"下記登録フォームへの入力を完了すると、アカウント申請が送信・審査されます。登録の確定は、追加の手続きが記載された電子メールで通知されます",
        "login_optional":"（省略可能）",
        "register_company_soldto":"デフォルトの販売先",
        "secure_update_pwd_validation_msg1":"12 文字以上",
        "secure_update_pwd_validation_msg2":"少なくとも 1 つの小文字を含む",
        "secure_update_pwd_validation_msg3":"少なくとも 1 つの大文字を含む",
        "secure_update_pwd_validation_msg4":"少なくとも 1 つの数字を含む",
        "secure_update_pwd_validation_msg5":"少なくとも 1 つの特殊文字を含む：( )~!@#$%^&*_-+=`|(){}[]:;\"'<>,?/",
        "secure_update_recentused_pwdMsg":"過去５世代のパスワードは使用できません。",
        "secure_update_pwd_personalInfo_msg":"個人情報や社名など検索可能な文字列は使用しないでください。",
        "secure_update_pwd_mustChange_msg":"Password must be changed once per year",
        "secure_update_pwd_doesnot_meetReq_msg":"選択したパスワードは要件を満たしていません。",
        "register_company_companyStateCode_japan":"都道府県*",
        "address_prefecture_invalid":"都道府県を選択してください",
        "":"Password and password confirmation do not match"

    }
}
